var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ai-suggestion-icon",class:{
    'ai-suggestion-icon-disabled': _vm.disabled,
    'ai-suggestion-icon-inline': _vm.inline,
  },attrs:{"type":"button","disabled":_vm.disabled,"title":"Sugerir con IA"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('AiSparkIcon',{attrs:{"size":14,"variant":"white"}}),_c('span',[_vm._v("Usar IA")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }